import React from "react";
import Select, { type SingleValue } from "react-select";
import { useScheduleTeam } from "../../../../hooks/scheduleTeam";
import { mobileSelectStyles, type MobileSelectOption } from "./mobileSelectStyles";

/**
 * On desktop the team switch lives in the header, which is hidden on mobile.
 * Only shown when the user belongs to more than one team.
 */
const MobileTeamSelect: React.FC = () => {
  const { myTeams, selectedTeamId, setSelectedTeamId, usesTeamSchedules } = useScheduleTeam();

  if (!usesTeamSchedules || myTeams.length < 2) {
    return null;
  }

  const options: MobileSelectOption[] = myTeams.map((team) => ({ value: team.id, label: team.name }));

  return (
    <div className="min-w-0">
      <span className="sr-only">Time</span>
      <Select<MobileSelectOption>
        aria-label="Time na agenda"
        options={options}
        value={options.find((option) => option.value === selectedTeamId) ?? null}
        onChange={(option: SingleValue<MobileSelectOption>) =>
          setSelectedTeamId(option ? Number(option.value) : null)
        }
        isSearchable={false}
        styles={mobileSelectStyles}
        menuPortalTarget={typeof document !== "undefined" ? document.body : undefined}
        menuPosition="fixed"
      />
    </div>
  );
};

export default MobileTeamSelect;
